
import DataMapper from '../DataMapper'
import HospitalInfraInvestigatorRM from '../../responsemodel/ReportRM/HospitalInfraInvestigatorRM'
import PathologistInvestigator from '../../../models/ReportModels/PathologistInvestigator'

export default class PathologistInvestigatorDataMapper extends DataMapper<HospitalInfraInvestigatorRM, PathologistInvestigator> {
    map = (rm: HospitalInfraInvestigatorRM) => new PathologistInvestigator(rm._id, rm.claim_number, rm.modified_on, rm.name)
}
